import React from 'react'
import ForgotP from '../../components/auth/ForgotP'

const ForgotPass = () => {
  return (
    <div>
        <ForgotP />
    </div>
  )
}

export default ForgotPass